export const VoiceoverModelId = {
    ElevenMultilingualV2: 'eleven_multilingual_v2',
    ElevenFlashV2: 'eleven_flash_v2',
    ElevenV3: 'eleven_v3',
} as const;
export type VoiceoverModelId = (typeof VoiceoverModelId)[keyof typeof VoiceoverModelId];

export const SUPPORTED_MODEL_IDS = new Set(Object.values(VoiceoverModelId));
export const DEFAULT_MODEL_ID = VoiceoverModelId.ElevenV3;
export const STREAMING_MODEL_IDS = new Set<VoiceoverModelId>([
    VoiceoverModelId.ElevenV3,
    VoiceoverModelId.ElevenMultilingualV2,
]);

export function isVoiceoverModelId(value: unknown): value is VoiceoverModelId {
    return typeof value === 'string' && SUPPORTED_MODEL_IDS.has(value as VoiceoverModelId);
}
